
import React from 'react';
import { useParams } from 'react-router-dom';
import DataLocation from "./LocationData"
import { NavLink } from 'react-router-dom';
import LocationPageForm from "./LocationPageForm";
import ReviesAll from "../ReviesAll";
import { testimonialData } from "../PricesComponents/PriceData";
import NoteFound from '../NoteFound';
const LocationMainPage = () => {

  const { slug } = useParams();
  const state = DataLocation.find(state => state.slug === slug);
  if (!state) {
    return <div><NoteFound /></div>;
  
  }

  return (
    <>
      <div className={"wrapper-location " + state.slug}>
      <section className="banner_section location_banner">
        <div className="container">
          <h1 className="all_main_heading mb-3" key={state.slug}>{state.mainHeading}</h1>

          <div className="location_banner_wrap">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                <div className="location_banner_text">
                  <h2>
                    {state.formHeading}
                  </h2>
                  <p>
                    {state.formText}
                  </p>
                  <NavLink className="class_us" to="/us/contact-us">
                    {state.formLink}
                  </NavLink>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-7">
                <div className="location_proposal_wrap">
                  <h3>GET MY FREE PROPOSAL</h3>
                  <LocationPageForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="seo_approch_sec text-center">
        <div className="container">
          <h2>{state.serviceBoxHeading}</h2>

          {state.serviceBoxTextItem.map((items)=>{
            return(
              <p className='all_main_discription'>{items.serviceBoxText}</p>
            )
          })}
          {
            state.serviceBoxHeading2 && 
            <h3 class="mb-1"><strong>{state.serviceBoxHeading2}</strong></h3>
          }
           {
            state.serviceBoxTextItem2 && 
            <p class="mb-3"><strong>{state.serviceBoxTextItem2}</strong></p>
          }
          <div className="row j-center mt-5">
            {state.serviceBox.map((item) => {

              return (
                <div className="col-12 col-sm-12 col-md-6 col-lg-3 mb-5 border-before">
                  <div className="approch_improve_text">
                    <img src={item.imgUrl} alt="img" />
                    <h3>
                      {item.serboxHead}
                    </h3>
                    <p>
                      {item.serboxtext}
                    </p>
                  </div>
                </div>
              )
            })}
          </div>
          <div className="strategies_wrap">
            <h3>
              {state.servDetailSubHeading}
            </h3>
            {
              state.servDetailTextItems && 
            
            state.servDetailTextItems.map((items)=>{
              return(
                <p className='mb-3'>
                {items.servDetailText}
                  </p>
              )
            })}
           
              <h3>
              {state.servDetailSubHeading2}
            </h3>
            {
              state.servDetailTextItems2 && 
            
            state.servDetailTextItems2.map((items)=>{
              return(
                <p className='mb-3'>
                {items.servDetailText}
                  </p>
              )
            })}
           
        
          </div>
          {
            state.roiFigure &&
          <figure className="roi_figure">
            <picture>
              <source media="(max-width:767px)" srcSet={state.roiFigure} />
              <img src={state.roiFigure} alt="img" />
            </picture>
            
            <figcaption className="roi_caption">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-5 col-lg-5"></div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-7">
                  <h4>
                    {state.roiHeading}
                  </h4>
                 
                    {state.roiTextItems.map((items)=>{
                      return(
                        <p>{items.roiText}</p>
                      )
                    })}
                  
                  <NavLink className="class_us" to="/us/contact-us">
                    {state.roilLink}
                  </NavLink>
                </div>
              </div>
            </figcaption>
          </figure>
}
          {
            state.achieveContent &&
            state.achieveContent.map((item)=>{
              return(
              <div class="strategies_wrap pb-2">
                <h3>{item.achieveHeading}</h3>
                <p>{item.achieveText}</p>
                <p className='mb-3'>{item.achieveText2}</p>
              </div>
              )
            })
          }
          <div className="navada_social text-center">
            <h3>{state.besrServHeading}</h3>
            <p>{state.besrServSubHeading}</p>
            <ul className='navada_Social_list'>
              {state.serviceIcon.map((item) => {
                return (
                  <li>
                    <a href={item.servIconHref} target="_blank" rel="noreferrer">
                      <img src={item.servicon} alt="img location" />
                    </a>
                  </li>
                )
              })}
            </ul>

          </div>
        </div>
      </section>
      <section className="seo_nevada_sec">
        <div className="container">
      
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-5">
              <h3>
                {state.navadaBoxHeading}
              </h3>

            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-7">
              <p>
                {state.navadaBoxText}
              </p>
            </div>

           {state.navadaBox && 
            <div className="row mt-5">

              {state.navadaBox.map((items) => {
                return (
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4 mb-5">
                    <div className="experienced_seo_team text-center">
                      <div className="seo_team_wrap">
                        <img src={items.boximg} alt="Ex Team icon" />
                        <h4>{items.boxHeading}</h4>
                        <p>
                          {items.boxText}
                        </p>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            }


          </div>
        </div>
      </section>
      {state.solutionHeading && state.solutionText &&
  <section className="strategies_wrap pt-5 pb-0"><div className="container">
  <h3 className="mb-3"> {state.solutionHeading} </h3>
  <p className="mb-5">{state.solutionText}</p>
  </div></section>
}
      <section className="tools_section text-center">
        <div className="container">
          <h3>{state.adsTitle}</h3>
          <ul className="tool_list row">
            <li>
              <img src="https://ezmarketingtech.s3.amazonaws.com/img/tool_img.png" alt="img" />
            </li>
            <li>
              <img src="https://ezmarketingtech.s3.amazonaws.com/img/tool_img2.png" alt="img" />
            </li>
            <li>
              <img src="https://ezmarketingtech.s3.amazonaws.com/img/tool_img3.png" alt="img" />
            </li>
            <li>
              <img src="https://ezmarketingtech.s3.amazonaws.com/img/tool_img4.png" alt="img" />
            </li>
            <li>
              <img src="https://ezmarketingtech.s3.amazonaws.com/img/tool_img5.png" alt="img" />
            </li>
          </ul>
        </div>
      </section>
      <ReviesAll
        mainclassName="home_restimonials price_testimonials"
        heading="Our Clients Review"
        SubHeading="What our client say about us"
        details={testimonialData}
      />

</div>
    </>
  );
};

export default LocationMainPage;